/**
 * @generated SignedSource<<1f657ce037d3f370773f6763dd721fec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditor_rateByRoom$data = {
  readonly __id: string;
  readonly room: {
    readonly id: string;
  };
  readonly roomRate: {
    readonly id: string;
    readonly priceNett: string | null;
    readonly roomPriceAdult: number;
    readonly roomPriceChild: number;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_rateByRoom">;
  readonly " $fragmentType": "RoomRatesTableRateEditor_rateByRoom";
};
export type RoomRatesTableRateEditor_rateByRoom$key = {
  readonly " $data"?: RoomRatesTableRateEditor_rateByRoom$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_rateByRoom">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditor_rateByRoom",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoomRate",
      "kind": "LinkedField",
      "name": "roomRate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceNett",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomPriceAdult",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomPriceChild",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditorForm_rateByRoom"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "RateByRoom",
  "abstractKey": null
};
})();

(node as any).hash = "9ca619d606043bb4b2b7060191e1e2ec";

export default node;
